import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { AiTwotoneHome, AiFillMail, AiFillPhone } from "react-icons/ai"
import { TbWorldSearch } from "react-icons/tb"
import { SlOrganization, SlCalender } from "react-icons/sl"
import { BiSolidEditLocation, BiSolidBookAlt } from "react-icons/bi"
import { FaMoneyCheckAlt } from "react-icons/fa"
import { AiOutlineFieldNumber } from "react-icons/ai"
import { Table } from "reactstrap"
import president from "../../assets/images/TheSigningOfficers/selvagiri.jpg"
import PageBanner from "../../layouts/PageBanner"
import expl from "../../assets/images/SATS_KIDS_EVENT_V1.6.jpg"
import bg from "../../assets/images/banner/bnr5.jpg"
import shape2 from "../../assets/images/pattern/shape2.png"
import shape3 from "../../assets/images/pattern/shape3.png"
import shape5 from "../../assets/images/pattern/shape5.png"
import shape1 from "../../assets/images/pattern/shape1.png"
import shape6 from "../../assets/images/pattern/shape6.png"
import { useDispatch, useSelector } from "react-redux"
import { fetchSelectedEvent,fetchSelectedPastEvent } from "../../features/Event/EventTBSlice"
import ApiServer, {
  Event_Cover_Image_Api,
  ImageApi,
  phoneNumber,
} from "../../helpers/Api_help"
import moment from "moment"

import BlogDetailsLeftBar from '../../components/BlogDetailsLeftBar';
import BlogDetailsPage from "../../components/BlogDetailsPage"

const Details = () => {
  const conatctblog = [
    { title: "San Antonio Tamil Sangam", image: <AiTwotoneHome /> },
    { title: "sats@satamilsangam.org", image: <AiFillMail /> },
    { title: "(210) 904-5052", image: <AiFillPhone /> },
    { title: "http://www.satamilsangam.org", image: <TbWorldSearch /> },
  ]
  const _id = localStorage.getItem("SelectEvent")
  const dispatch = useDispatch()
  const { SelectedEventData,SelectedPastEventData, TBisSuccess, TBisfail } = useSelector(
    (state) => state.EventTBReducer
  )

  // useEffect(() => {
  //   console.log("comes in useeffect");
  //   dispatch(fetchSelectedEvent({ _id }))
  //   dispatch(fetchSelectedPastEvent({_id}))
  // }, [])
  useEffect(() => {
  console.log("Selected Event ID:", _id);
  
  if (_id) {
    dispatch(fetchSelectedEvent({ _id }))
    dispatch(fetchSelectedPastEvent({ _id }))
  } else {
    console.error("No event ID found in localStorage");
  }
}, [])

  return (

    <div className="page-content bg-white">
      <PageBanner
          maintitle="Home"
          pagetitle="Event Information"
          bgColor={"red"}
        />
      <section className="content-inner-2" style={{paddingTop:30 }}>
        <div className="container">
          <div className="row ">
            <div className="col-xl-12 col-lg-12 m-b30">
              {/* {SelectedEventData && <BlogDetailsLeftBar */}
             {/* ✅ PAST EVENT UI */}
{SelectedPastEventData?.length > 0 ? (
  <PastEventDetails SelectedPastEventData={SelectedPastEventData} />
) : (
  /* ✅ CURRENT / UPCOMING EVENT UI */
  SelectedEventData && (
    <BlogDetailsPage SelectedEventData={SelectedEventData} />
  )
)}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Details


const PastEventDetails = ({ SelectedPastEventData }) => {
  return (
    <>
      {SelectedPastEventData.map((event, eind) => (
        <div key={eind + "evntinfo"}>
          <div className="dz-card blog-single sidebar">
            <h1 className="dz-title">
              {event?.event_name || event.name}
            </h1>

            <div className="row">
              <div className="col-md-6">
                <div className="dz-media">
                  <img
                    src={`${ApiServer}assets/event_cover/${
                      event?.event_photos || event.image_name
                    }`}
                    alt=""
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="dz-info">
                  <div className="dz-meta">
                    <ul>
                      <li className="post-date">
                        <i className="fa-solid fa-calendar-days"></i>
                        {moment
                          .parseZone(
                            event?.event_startdate_time || event.start_date
                          )
                          .format("MMMM Do YYYY")}
                      </li>
                    </ul>
                  </div>

                  <div className="dz-post-text">
                    <h4 className="title">Description</h4>

                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          event?.event_desc || event?.description,
                      }}
                    />

                    {event?.venues?.map((venue, index) => (
                      <div key={index}>
                        <h6 className="title mt-3">{venue.venue}</h6>

                        <span>
                          {moment(venue.start_datetime).format("LLLL")}
                        </span>
                        <br />

                        <span>
                          {venue.address}, {venue.city}
                        </span>
                        <br />

                        <span>{venue.country}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
